import urls from "./urls";
import {handleFetchError} from "./dom-manipulation";
import {getBillingRequestHeaders} from './billing-context';


export function getCookie(name) {
    const cookieValue = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return cookieValue ? cookieValue.pop() : '';
}


export async function simpleFetch(url, method = 'GET') {
    try {
        return await fetchData({
            url: url,
            method: method, // Explicit, even if it's the default
        });
    } catch (error) {
        handleFetchError(error);
        throw error; // or return a default/error value, depending on your needs
    }
}


export async function fullFetch(config) {
    try {
        return await fetchData(config);
    } catch (error) {
        handleFetchError(error);
        throw error; // or return a default/error value, depending on your needs
    }
}


export async function fetchData({url, data = null, method = 'GET', headers = {}, signal = null, expectedStatusCodes = []}) {
    const csrftoken = getCookie('csrftoken');
    let options = {
        method: method,
        credentials: 'include',
        headers: {
            'X-CSRFToken': csrftoken,
            ...getBillingRequestHeaders(url),
            ...headers
        },
        signal
    };

    if (data && method.toUpperCase() !== "GET") {
        options.body = data;
    }


    const response = await fetch(url, options);
    if ((expectedStatusCodes.length > 0 && !expectedStatusCodes.includes(response.status)) || !response.ok) {

    }

    if ((expectedStatusCodes.length === 0 && !response.ok) ||
        (expectedStatusCodes.length > 0 &&
            !expectedStatusCodes.includes(response.status))) {
        let data;
        try {
            data = await response.json();
        } catch (err) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        if (data.hasOwnProperty('error')) {
            throw new Error(data.error);
        } else {
            throw data;
        }
    } else {
        let data;
        try {
            data = await response.json();
        } catch (err) {
            data = response
        }

        return data
    }


}

export async function fetchDataOld(url, method, data, headers = {}, signal = null) {
    const csrftoken = getCookie('csrftoken');
    let options = {
        method: method,
        credentials: 'include',
        headers: {
            'X-CSRFToken': csrftoken,
            ...getBillingRequestHeaders(url),
            ...headers
        },
        signal
    };

    if (data) {
        options.body = data;
    }


    const response = await fetch(url, options);
    if (!response.ok) {
        let data;
        try {
            data = await response.json();
        } catch (err) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        if (data.hasOwnProperty('error')) {
            throw new Error(data.error);
        } else {
            console.log('data', data)
            throw new Error(data);
        }
    } else {
        let data;
        try {
            data = await response.json();
        } catch (err) {
            data = response
        }

        return data
    }


}
